import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/api/queryKeys';
import { fetchClassCategories, type ClassCategory } from '@/features/class/boardsApi';

/**
 * React Query hook for the user's profile class categories
 * (`GET /midl/api/v3/class/category`). This is the authoritative category
 * source for the Manage categories popup because it includes empty
 * categories the login `boardWithCategory[]` payload omits.
 *
 * Disabled until `userId` is known so it doesn't fire before auth hydrates.
 */
export function useClassCategories(userId: number | string | null | undefined) {
  return useQuery<ClassCategory[]>({
    queryKey: queryKeys.class.categories,
    queryFn: fetchClassCategories,
    enabled: userId != null && String(userId).length > 0,
    staleTime: 5 * 60 * 1000,
  });
}
